import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { NewTitleGraphqlFragmentDoc } from '../fragments/NewTitle.fragment';
import { SponsoredAdFragmentFragmentDoc } from '../fragments/SponsoredAd.fragment';
export type GetNewTitlesQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	date: Types.Scalars['Date']['input'];
	language: Types.Scalars['Language']['input'];
	filter?: Types.InputMaybe<Types.TitleFilter>;
	after?: Types.InputMaybe<Types.Scalars['String']['input']>;
	first?: Types.Scalars['Int']['input'];
	profile?: Types.InputMaybe<Types.PosterProfile>;
	format?: Types.InputMaybe<Types.ImageFormat>;
	backdropProfile?: Types.InputMaybe<Types.BackdropProfile>;
	priceDrops: Types.Scalars['Boolean']['input'];
	platform: Types.Platform;
	bucketType?: Types.InputMaybe<Types.NewDateRangeBucket>;
	pageType?: Types.NewPageType;
	showDateBadge: Types.Scalars['Boolean']['input'];
	availableToPackages?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
	allowSponsoredRecommendations?: Types.InputMaybe<Types.SponsoredRecommendationsInput>;
}>;

export type GetNewTitlesQuery = {
	__typename?: 'Query';
	newTitles: {
		__typename?: 'NewTitlesConnection';
		totalCount: number;
		edges?: Array<{
			__typename?: 'NewTitlesEdge';
			cursor: string;
			newOffer?: {
				__typename?: 'Offer';
				id: string;
				standardWebURL?: string | null;
				retailPrice?: string | null;
				retailPriceValue?: number | null;
				lastChangeRetailPrice?: string | null;
				lastChangeRetailPriceValue?: number | null;
				lastChangePercent?: number | null;
				currency?: string | null;
				presentationType: Types.PresentationType;
				monetizationType: Types.MonetizationType;
				newElementCount?: number | null;
				package: {
					__typename?: 'Package';
					id: string;
					packageId: number;
					clearName: string;
					shortName: string;
				};
			} | null;
			node:
				| {
						__typename?: 'Movie';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						content: {
							__typename?: 'MovieContent';
							title: string;
							shortDescription?: string | null;
							fullPath: string;
							posterUrl?: string | null;
							runtime?: number | null;
							isReleased: boolean;
							scoring: {
								__typename?: 'Scoring';
								imdbVotes?: number | null;
								imdbScore?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							genres: Array<{ __typename?: 'Genre'; translation: string }>;
							upcomingReleases?: Array<{
								__typename?: 'UpcomingRelease';
								releaseDate?: any | null;
								releaseCountDown?: number | null;
								package?: { __typename?: 'Package'; id: string; shortName: string } | null;
							}>;
						};
						availableTo?: Array<{
							__typename?: 'AvailableTo';
							availableCountDown: number;
							availableToDate: any;
							package: { __typename?: 'Package'; id: string; shortName: string };
						}>;
				  }
				| {
						__typename?: 'Season';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						show: {
							__typename?: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							content: {
								__typename?: 'ShowContent';
								title: string;
								shortDescription?: string | null;
								fullPath: string;
								posterUrl?: string | null;
								runtime?: number | null;
								scoring: {
									__typename?: 'Scoring';
									imdbVotes?: number | null;
									imdbScore?: number | null;
									tmdbPopularity?: number | null;
									tmdbScore?: number | null;
								};
								genres: Array<{ __typename?: 'Genre'; translation: string }>;
							};
							likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							seenState: { __typename?: 'ShowSeenState'; progress: number };
						};
						content: {
							__typename?: 'SeasonContent';
							seasonNumber: number;
							title: string;
							shortDescription?: string | null;
							fullPath: string;
							posterUrl?: string | null;
							runtime?: number | null;
							isReleased: boolean;
							scoring: {
								__typename?: 'Scoring';
								imdbVotes?: number | null;
								imdbScore?: number | null;
								tmdbPopularity?: number | null;
								tmdbScore?: number | null;
							};
							genres: Array<{ __typename?: 'Genre'; translation: string }>;
							upcomingReleases?: Array<{
								__typename?: 'UpcomingRelease';
								releaseDate?: any | null;
								releaseCountDown?: number | null;
								package?: { __typename?: 'Package'; id: string; shortName: string } | null;
							}>;
						};
						availableTo?: Array<{
							__typename?: 'AvailableTo';
							availableCountDown: number;
							availableToDate: any;
							package: { __typename?: 'Package'; id: string; shortName: string };
						}>;
				  };
		}> | null;
		sponsoredAd?: {
			__typename?: 'SponsoredRecommendationAd';
			bidId: string;
			holdoutGroup: boolean;
			campaign: {
				__typename?: 'SponsoredRecommendationCampaign';
				hideRatings: boolean;
				promotionalImageUrl?: string | null;
				watchNowLabel?: string | null;
				externalTrackers: Array<{
					__typename?: 'ExternalTracker';
					type: Types.ExternalTrackerType;
					data: string;
				}>;
				watchNowOffer: {
					__typename?: 'Offer';
					standardWebURL?: string | null;
					presentationType: Types.PresentationType;
					monetizationType: Types.MonetizationType;
					package: {
						__typename?: 'Package';
						id: string;
						packageId: number;
						shortName: string;
						clearName: string;
						icon: string;
					};
				};
				node:
					| { __typename?: 'Article'; id: string }
					| { __typename?: 'Author'; id: string }
					| { __typename?: 'Bundle'; id: string }
					| { __typename?: 'Device'; id: string }
					| { __typename?: 'Episode'; id: string }
					| { __typename?: 'GenericTitleList'; id: string }
					| { __typename?: 'Genre'; id: string }
					| {
							__typename?: 'Movie';
							objectId: number;
							objectType: Types.ObjectType;
							id: string;
							content: {
								__typename?: 'MovieContent';
								fullPath: string;
								posterUrl?: string | null;
								title: string;
								originalReleaseYear?: number | null;
								isReleased: boolean;
								scoring: { __typename?: 'Scoring'; imdbScore?: number | null };
								externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
							offers: Array<{
								__typename?: 'Offer';
								monetizationType: Types.MonetizationType;
								presentationType: Types.PresentationType;
								id: string;
								package: { __typename?: 'Package'; id: string; packageId: number };
							}>;
							watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					  }
					| { __typename?: 'MultiStepSportEvent'; id: string }
					| { __typename?: 'Offer'; id: string }
					| { __typename?: 'Package'; id: string }
					| { __typename?: 'Page'; id: string }
					| { __typename?: 'Person'; id: string }
					| { __typename?: 'Season'; id: string }
					| {
							__typename?: 'Show';
							objectId: number;
							objectType: Types.ObjectType;
							id: string;
							content: {
								__typename?: 'ShowContent';
								fullPath: string;
								posterUrl?: string | null;
								title: string;
								originalReleaseYear?: number | null;
								isReleased: boolean;
								scoring: { __typename?: 'Scoring'; imdbScore?: number | null };
								externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
								backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							};
							offers: Array<{
								__typename?: 'Offer';
								monetizationType: Types.MonetizationType;
								presentationType: Types.PresentationType;
								id: string;
								package: { __typename?: 'Package'; id: string; packageId: number };
							}>;
							watchlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							seenState: { __typename?: 'ShowSeenState'; seenEpisodeCount: number };
					  }
					| { __typename?: 'SingleStepSportEvent'; id: string }
					| { __typename?: 'SportCompetitionV2'; id: string }
					| { __typename?: 'SportCompetitorV2'; id: string }
					| { __typename?: 'Url'; id: string };
			};
		} | null;
		pageInfo: { __typename?: 'PageInfo'; endCursor: string; hasPreviousPage: boolean; hasNextPage: boolean };
	};
};

export const GetNewTitlesDocument = gql`
	query GetNewTitles(
		$country: Country!
		$date: Date!
		$language: Language!
		$filter: TitleFilter
		$after: String
		$first: Int! = 10
		$profile: PosterProfile
		$format: ImageFormat
		$backdropProfile: BackdropProfile
		$priceDrops: Boolean!
		$platform: Platform!
		$bucketType: NewDateRangeBucket
		$pageType: NewPageType! = NEW
		$showDateBadge: Boolean!
		$availableToPackages: [String!]
		$allowSponsoredRecommendations: SponsoredRecommendationsInput
	) {
		newTitles(
			country: $country
			date: $date
			filter: $filter
			after: $after
			first: $first
			priceDrops: $priceDrops
			bucketType: $bucketType
			pageType: $pageType
			allowSponsoredRecommendations: $allowSponsoredRecommendations
		) {
			totalCount
			edges {
				...NewTitleGraphql
			}
			sponsoredAd {
				...SponsoredAdFragment
			}
			pageInfo {
				endCursor
				hasPreviousPage
				hasNextPage
			}
		}
	}
	${NewTitleGraphqlFragmentDoc}
	${SponsoredAdFragmentFragmentDoc}
`;
